import React, { useState } from 'react';
import CalculatorForm from './CalculatorForm';
import CalculatorResults from './CalculatorResults';
import CalciumRuler from './CalciumRuler';

export default function CalculatorSection() {
  const [calcium, setCalcium] = useState('');
  const [albumin, setAlbumin] = useState('');
  const [isSI, setIsSI] = useState(false);
  const parsedCa = parseFloat(calcium);
  const parsedAlb = parseFloat(albumin);
  const isValid = !isNaN(parsedCa) && !isNaN(parsedAlb) && parsedCa > 0 && parsedAlb > 0;
  let adjustedCa = null;
  let diff = null;

  if (isValid) {
    if (isSI) {
      adjustedCa = parsedCa + 0.02 * (40 - parsedAlb);
    } else {
      adjustedCa = parsedCa + 0.8 * (4 - parsedAlb);
    }
    diff = adjustedCa - parsedCa;
  }

  return (
    <div className="calculator-stage">
      <div className="calculator-controls">
        <CalculatorForm
          calcium={calcium}
          setCalcium={setCalcium}
          albumin={albumin}
          setAlbumin={setAlbumin}
          isSI={isSI}
          setIsSI={setIsSI}
        />
        {isValid && (
          <CalculatorResults
            calcium={parsedCa}
            adjustedCa={adjustedCa}
            diff={diff}
            isSI={isSI}
            albumin={parsedAlb}
          />
        )}
      </div>
      <CalciumRuler
        calcium={isValid ? parsedCa : null}
        adjustedCa={isValid ? adjustedCa : null}
        albumin={albumin ? parsedAlb : null}
        isSI={isSI}
      />
    </div>
  );
}
